import * as NotarizationAPI from "../../API/notarization.api";
import { completeDocument, declineDocument, appendNotarialAct, removeNotarialAct, notarialActs, refreshExistingDocument } from "../../API/notarizationDocument.api";

export class NotarizationDocuments {
	constructor(API) {
		this.modules = {
			API
		};
	}
	state() {
		return {
			notarizationDocuments: [],
			notarialActs: []
		};
	}
	mutations = {
		documents(state, documents) {
			state.notarizationDocuments = documents;
		},
		updateDocumentStatus(state, { documentId, status }) {
			state.notarizationDocuments.find(d => d.id === documentId).signingStatusId = status;
		},
		notarialActs(state, notarialActs) {
			state.notarialActs = notarialActs;
		}
	}
	actions = {
		loadDocuments({ state, dispatch }) {
			if (state.API.notarizationId)
				return dispatch(`API/load`, { apiPromise: NotarizationAPI.documents(state.API.notarizationId), successMutation: `documents` });
		},
		loadNotarialActs({ state, dispatch }) {
			return dispatch(`API/load`, { apiPromise: notarialActs(state.API.notarizationId, state.AnnotationsSync.documentId), successMutation: `notarialActs` });
		},
		completeDocument({ state }, data) {
			return completeDocument(state.API.notarizationId, state.AnnotationsSync.documentId, data);
		},
		declineDocument({ state }) {
			return declineDocument(state.API.notarizationId, state.AnnotationsSync.documentId);
		},
		appendNotarialAct({state}, data) {
			return appendNotarialAct(state.API.notarizationId, state.AnnotationsSync.documentId, data);
		},
		removeNotarialAct({state}, notarialActId) {
			return removeNotarialAct(state.API.notarizationId, state.AnnotationsSync.documentId, notarialActId);
		},
		refreshExistingDocument({ state }, documentId) {			
			return refreshExistingDocument(state.API.notarizationId, documentId);
		},
	}
}
